import {FC} from 'react';

interface ISegmentedControlProps {
  options: {key: string; label: string}[];
  value: string;
  onChange: (key: string) => void;
}

export const SegmentedControl: FC<ISegmentedControlProps> = ({options, value, onChange}) => (
  <div className="inline-flex max-w-full flex-wrap rounded-lg bg-gray-100 p-1">
    {options.map((option) => (
      <button
        key={option.key}
        type="button"
        aria-pressed={value === option.key}
        onClick={() => onChange(option.key)}
        className={`rounded-md px-3 py-1.5 text-[13px] font-medium transition-colors ${
          value === option.key ? 'bg-white text-[#654dcb] shadow-sm' : 'text-gray-500 hover:text-[#33364b]'
        }`}>
        {option.label}
      </button>
    ))}
  </div>
);
